import { Controller } from "@hotwired/stimulus"

// Savant signing page: typed signature by default, optional drawn signature
// on a canvas (mouse, pen or finger). The drawing is sent as a PNG data URL.
export default class extends Controller {
  static targets = ["name", "typed", "kind", "dataUrl", "typedPanel", "drawPanel", "canvas"]

  connect() {
    this.drawn = false
    this.typedEdited = false
  }

  syncTyped() {
    if (!this.typedEdited && this.hasTypedTarget) this.typedTarget.value = this.nameTarget.value
  }

  showDraw() {
    this.kindTarget.value = "drawn"
    this.typedPanelTarget.hidden = true
    this.drawPanelTarget.hidden = false
    this.setupCanvas()
  }

  showTyped() {
    this.kindTarget.value = "typed"
    this.drawPanelTarget.hidden = true
    this.typedPanelTarget.hidden = false
  }

  clear() {
    const ctx = this.canvasTarget.getContext("2d")
    ctx.clearRect(0, 0, this.canvasTarget.width, this.canvasTarget.height)
    this.drawn = false
  }

  prepare(event) {
    if (this.kindTarget.value !== "drawn") return
    if (!this.drawn) {
      event.preventDefault()
      alert("Please draw your signature, or choose Type instead.")
      return
    }
    this.dataUrlTarget.value = this.canvasTarget.toDataURL("image/png")
  }

  setupCanvas() {
    if (this.canvasReady) return
    this.canvasReady = true
    const canvas = this.canvasTarget
    const ctx = canvas.getContext("2d")
    ctx.lineWidth = 2.5
    ctx.lineCap = "round"
    ctx.strokeStyle = "#111"
    let drawing = false
    const point = (e) => {
      const rect = canvas.getBoundingClientRect()
      return [(e.clientX - rect.left) * (canvas.width / rect.width), (e.clientY - rect.top) * (canvas.height / rect.height)]
    }
    canvas.addEventListener("pointerdown", (e) => {
      drawing = true
      canvas.setPointerCapture(e.pointerId)
      ctx.beginPath()
      ctx.moveTo(...point(e))
    })
    canvas.addEventListener("pointermove", (e) => {
      if (!drawing) return
      ctx.lineTo(...point(e))
      ctx.stroke()
      this.drawn = true
    })
    const stop = () => { drawing = false }
    canvas.addEventListener("pointerup", stop)
    canvas.addEventListener("pointercancel", stop)
  }
}
